import React, { useState } from "react";
import "./Craft.css";
import craft1 from "../marketplaceassets/craft1.png";
import craft2 from "../marketplaceassets/craft2.png";
import craft3 from "../marketplaceassets/craft3.png";
import craft4 from "../marketplaceassets/craft4.png";

export default function Craft() {
  const cards = [
    { img: craft1, title: "Creator-focused dashboards", desc: "Dashboards designed for creators to easily manage, mint, and track NFTs, providing complete control over their digital assets and performance metrics." },
    { img: craft2, title: "Seamless buyer journeys", desc: "Simplified navigation and intuitive workflows that guide buyers through discovering, purchasing, and managing NFTs efficiently and effortlessly." },
    { img: craft3, title: "Responsive and mobile-first layouts", desc: "Optimized designs that ensure smooth, consistent experiences across all devices, including smartphones, tablets, and desktops." },
    { img: craft4, title: "Web3-friendly user interfaces", desc: "Interfaces built to support blockchain interactions, crypto wallets, and decentralized features while keeping the user experience intuitive and engaging." }
  ];

  const isMobile = window.innerWidth <= 576;
  const visibleCards = isMobile ? 1 : 2;
  const maxIndex = cards.length - visibleCards;

  const [currentIndex, setCurrentIndex] = useState(0);

  const goToSlide = (index) => {
    if (index > maxIndex) {
      setCurrentIndex(0);
    } else if (index < 0) {
      setCurrentIndex(maxIndex);
    } else {
      setCurrentIndex(index);
    }
  };

  return (
    <div id="marketplace-craft" className="marketmainclass">
<h2 className="heading"> NFT Marketplace Design</h2> <p className="subheading"> Creating intuitive, engaging NFT marketplaces for web and mobile users.</p>
      <div className="cards">
        {cards.map((card, i) => (
          <div className="card" key={i}>
            <img src={card.img} alt="" />
            <h3>{card.title}</h3>
            <p>{card.desc}</p>
          </div>
        ))}
      </div>

     <div className="carousel-container">
        <div className="carousel-wrapper">
          <div
            className="carousel-track"
            style={{
              transform: `translateX(-${currentIndex * (isMobile ? 100 : 50)}%)`
            }}
          >
            {cards.map((card, index) => (
              <div className="carousel-card" key={index}>
                <img src={card.img} alt="" />
                <h3>{card.title}</h3>
                <p>{card.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* DOTS */}
        <div className="carousel-nav dots">
          {Array.from({ length: maxIndex + 1 }).map((_, index) => (
            <span
              key={index}
              className={`dot ${currentIndex === index ? "active" : ""}`}
              onClick={() => goToSlide(index)}
            />
          ))}
        </div>

      </div>
    </div>
  );
}
